import { useState, useCallback } from "react";
import { getOffers, getMyOffers, getOffersStats, createOffer, updateOffer, deleteOffer, checkOfferDelete } from "../../../../api/marketplace";

export function useOffers() {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState(null);

  const fetchOffers = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await getOffers(params);
      setOffers(res.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchMyOffers = useCallback(async (params = {}) => {
    setLoading(true);
    setError(null);
    try {
      const res = await getMyOffers(params);
      setOffers(res.data.offers || res.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchStats = useCallback(async () => {
    try {
      const res = await getOffersStats();
      setStats(res.data);
    } catch (err) {
      console.error("Failed to fetch offers stats:", err);
    }
  }, []);

  const create = useCallback(async (data) => {
    const res = await createOffer(data);
    await fetchOffers();
    return res.data;
  }, [fetchOffers]);

  const update = useCallback(async (id, data) => {
    const res = await updateOffer(id, data);
    await fetchOffers();
    return res.data;
  }, [fetchOffers]);

  const remove = useCallback(async (id) => {
    const res = await deleteOffer(id);
    await fetchOffers();
    return res.data;
  }, [fetchOffers]);

  const checkDelete = useCallback(async (id) => {
    const res = await checkOfferDelete(id);
    return res.data;
  }, []);

  return {
    offers,
    loading,
    error,
    stats,
    fetchOffers,
    fetchMyOffers,
    fetchStats,
    create,
    update,
    remove,
    checkDelete,
    setOffers,
  };
}
